import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Waves from 'node-waves';
import { dates, dateMonthAndYear, getWeeknumber } from '../Util/dateTime';


class WeekSwitch extends Component {
  constructor(props) {
    super(props);
    var initdate = props.initialDate;
    var daysToSubtract = initdate.getDay() > 0 ? 1 : -6; //sunday is the exception
    initdate.setDate(initdate.getDate()- (initdate.getDay() - daysToSubtract));
    this.state ={
      date: initdate
    }
  }
  componentDidMount = () => {
    if (!this.props.disableOnChangeOnMount)
      this.props.onChange(this.state.date);

    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  nextWeek = () => {
    var date = this.state.date;
    date.setDate(date.getDate() + 7);
    this.setState({
      date: date
    });
    this.props.onChange(date)
  };
  previousWeek = () => {
    var date = this.state.date;
    date.setDate(date.getDate() - 7);
    this.setState({
      date: date
    });
    this.props.onChange(date)
  };
  getMondayDate = () => {
    return this.state.date
  };
  render() {
    var currentDate = this.state.date;
    var weekNumber = getWeeknumber(currentDate);
    var monthAndYear = dateMonthAndYear(currentDate);
    var tmpDate = new Date(currentDate);
    tmpDate.setDate(tmpDate.getDate() + 6);
    let isCurrentWeek = dates.inRange(new Date(), currentDate, tmpDate);
    return (
        <div style={styles.dateSwitch}>
          <div style={styles.i} onClick={this.previousWeek} className="fa fa-chevron-left waves-icon"> </div>
          <span style={styles.span}>
                uge {weekNumber}
          </span>
          <span style={styles.span}> - </span>
          <span style={styles.span}>
            {monthAndYear}
          </span>
          {isCurrentWeek && !this.props.allowFuture ? null : <div style={styles.i} onClick={this.nextWeek} className="fa fa-chevron-right waves-icon"></div>}
        </div>
    );
  }
}
var styles = {
  dateSwitch : {
    fontSize: '16px'
  },
  i:{
    height: '30px',
    width: '30px',
    lineHeight: '30px',
    overflow: 'visible'
  },
  span : {
    fontWeight: '600',
    padding: '0 8px',
    cursor: 'auto'
  }
}
  WeekSwitch.propTypes = {
    initialDate: PropTypes.objectOf(Date).isRequired,
    onChange : PropTypes.func.isRequired,
    allowFuture: PropTypes.bool,
    disableOnChangeWhenMounted: PropTypes.bool
  };
export default WeekSwitch;


// WEBPACK FOOTER //
// ./src/App/Common/weekSwitch.jsx